export default "__VITE_ASSET__DYcmbtAG__"